
























































import {Component, Mixins, Prop, Watch} from "vue-property-decorator";
import XForm from "@/components/SimpleForm.vue";
import { paymentForm } from "@/assets/scripts/form-fields/main";
import {validationMixin} from "vuelidate";
import AppApiMixin from "@/components/mixins/AppApi.vue";
import {mapGetters, mapState} from "vuex";

const { values, attrs, validations, errors } = paymentForm;

@Component({
  components: {
    XForm,
  },
  computed: {
    ...errors,
    ...mapState({ appEnviroment: "appEnviroment" }),
    ...mapGetters({
      contractId: "contract/id",
    }),
  },
  mixins: [validationMixin],
  validations,
})
class PaymentForm extends Mixins(AppApiMixin, XForm) {
  [x: string]: any

  @Prop({ required: true }) amount!: number;
  @Prop({ required: true }) docs!: any[];

  values = values
  defaultValues: {[x: string]: any} = {}
  allFieldAttrs = attrs;

  useSubmitButtonLoading = false;
  submitSuccess = "";
  submitError = "";

  mounted() {
    const {amount, docs, total} = this;
    this.values = {...this.values, ...{amount, docs, total}}; // ...this.$attrs
    this.defaultValues = {...this.values, ...{amount, docs, total}}; // ...this.$attrs
  }

  async submitForm() {
    this.useSuccessAlert = false
    this.useSubmitButtonLoading = true

    const formData = new FormData
    for (let key in this.values) {
      formData.append(key, this.values[key]);
    }

    formData.append('contractId', this.contractId);

    try {
      const data = await this.getPaymentURL(formData)

      if(data && data.result && (data.url) != 0) {
        window.location.href = data.url;
      }
    } catch (e) {
      console.log("error", e);
      this.submitError = e.data;
    }
    this.submitSuccess = '';
    this.useSubmitButtonLoading = false
  }

  @Watch("amount")
  public setAmountChanged() {
    const {amount} = this;
    const total = this.calcTotal(amount);
    this.values = {...this.values, ...{amount, total}};
  }
  @Watch("docs")
  public setDocsChanged() {
    this.values = {...this.values, docs: JSON.stringify(this.docs)};
  }

  get sumDisabled() {
    // если есть документы, то редактирование суммы заблокировано
    const disabled = !!this.docs.length;
    if (disabled) {
      this.values['description'] = "";
    }
    return disabled;
  }

  calcTotal(amount) {
    return amount + (amount * (+this.appEnviroment.constants['PaymentFee'] || 0))
  }

  changeAmount() {
    this.values['total'] = this.calcTotal(this.values['amount']);
  }
}

export default PaymentForm;
